import React, { useState, useEffect, useRef } from 'react'
import { Usecartcontaxt } from './cartcontaxt/cart_contaxt';
import Formatprice from './Helper/Formatprice';
import { NavLink, useNavigate } from 'react-router-dom';
import { UseGlobellogin } from './Logincontaxt.jsx/Logincontex';
import styled from "styled-components";
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';
function Checkout() {
  const Navigate = useNavigate();
  const formRef = useRef(null);
  const { databasecartdata, order_total, totalCartPrice } = Usecartcontaxt();
  const { refresh, setrefresh, setsuccessfully, userId, seterrormessage } = UseGlobellogin();
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [copyText, setCopyText] = useState('Copy');
  const [loading, setloading] = useState(false);
  const [paymentScreenshot, setPaymentScreenshot] = useState(null); // this should be a File
  const email = localStorage.getItem('userEmail');
  const username = localStorage.getItem('user_Name');
  const parts = username?.trim().split(" ") || [];

  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ") || "";
  const [formData, setFormData] = useState({
    billing: {
      First_name: firstName ? firstName : "",
      Lirst_name: lastName ? lastName : "",
      your_company_name: "",
      street_address: "",
      Apartment_no: "",
      city: "",
      Country_name: "",
      postcode: "",
      Email_address: email ? email : "",
      phone_no: "",
      utr_no: "",
    },

  });
  const [bannerData, setBannerImage] = useState([]);
  const [bannerLoading, setBannerLoading] = useState(true);

  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        setBannerLoading(true);
        const response = await fetch(`${BASE_URL}/banner/?page=checkout`);
        const result = await response.json();
        setBannerImage(result.data[0]);
      } catch (error) {
        console.error('Error fetching banner:', error);
      } finally {
        setBannerLoading(false);
      }
    };

    fetchBannerImage();
  }, []);

  // Handle input changes
  const handleInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };


  const submitform = async (e) => {
    setloading(true);
    e.preventDefault();
    const cartIds = databasecartdata.map(item => item.id);
    //  const orderData = {
    //       billing: formData.billing,
    //       user_id: localStorage.getItem("user_id"),
    //       cartitem_ids:cartIds
    //   };

    const formDataToSend = new FormData();

    formDataToSend.append("First_name", formData.billing.First_name);
    formDataToSend.append("Lirst_name", formData.billing.Lirst_name);
    formDataToSend.append("your_company_name", formData.billing.your_company_name);
    formDataToSend.append("street_address", formData.billing.street_address);
    formDataToSend.append("Apartment_no", formData.billing.Apartment_no);
    formDataToSend.append("city", formData.billing.city);
    formDataToSend.append("Country_name", formData.billing.Country_name);
    formDataToSend.append("postcode", formData.billing.postcode);
    formDataToSend.append("Email_address", formData.billing.Email_address);
    formDataToSend.append("phone_no", formData.billing.phone_no);
    formDataToSend.append("utr_no", formData.billing.utr_no);
    formDataToSend.append("user_id", userId);
    if (paymentScreenshot) {
      formDataToSend.append("payment_screenshot", paymentScreenshot);
    }

    cartIds.forEach(id => {
      formDataToSend.append("cartitem_ids", id);
    })

    try {
      const response = await fetch(`${BASE_URL}/orderdetail/`, {
        method: "post",
        body: formDataToSend,
      })
      const resData = await response.json();
      if (response.ok) {
        setrefresh(!refresh);
        setsuccessfully(resData.message);
        setTimeout(() => {
          setsuccessfully(false);
        }, 3000);

        setIsOrderPlaced(true);
        setShowModal(false);
        setTimeout(() => {
          setIsOrderPlaced(false);
        }, 5000);
        setPaymentScreenshot(null);
        Navigate("/course");

        setFormData({
          billing: {
            First_name: "",
            Lirst_name: "",
            your_company_name: "",
            street_address: "",
            Apartment_no: "",
            city: "",
            countryName: "",
            postcode: "",
            Email_address: "",
            phone_no: "",
            utr_no: "",
          },
        })
      }
      else {
        // seterrormessage(resData.message);
        // setTimeout(() => {
        //   seterrormessage(false); 
        // }, 3000); 
      }

    } catch (error) {
      console.log(error);
    }
    finally {
      setloading(false);

    }
  };
  return (
    <>
      {
        bannerLoading && bannerData && bannerData.image ? (
          <SubLoading />
        ) : (
          <div className="breadcumb-wrapper"

            style={{
              backgroundImage: `url(${BASE_URL}${bannerData.image})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: "50px"
            }}

            data-overlay="title" data-opacity={8} >
            <div className="breadcumb-shape" data-bg-src="assets/img/bg/breadcumb_shape_1_1.png">
            </div>
            <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
              <img src="assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
            </div>
            <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
              <img src="assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
            </div>
            <div className="container">
              <div className="breadcumb-content text-center">
                <h1 className="breadcumb-title">Checkout</h1>
                <ul className="breadcumb-menu">
                  <li><NavLink to="/">Home</NavLink></li>
                  <li>Checkout</li>
                </ul>
              </div>
            </div>
          </div>
        )}

      <div className="th-checkout-wrapper space-top space-extra-bottom">
        <div className="container">
          <form ref={formRef} onSubmit={submitform} className="woocommerce-checkout mt-40">
            <div className="row ">
              <div className="col-lg-5">
                <h2 className="h4">Billing Details</h2>
                <div className="row">
                  {/* <div className="col-12 form-group">
              <select
                className="form-select"
                value={formData.billing.country}
                onChange={(e) =>handleInputChange("billing", "country", e.target.value)}
                required
             >
                <option>United Kingdom (UK)</option>
                <option>United State (US)</option>
                <option>Equatorial Guinea (GQ)</option>
                <option>Australia (AU)</option>
                <option>Germany (DE)</option>
              </select>
            </div> */}
                  {/* <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First Name"

                      value={formData.billing.First_name}

                      onChange={(e) =>
                        handleInputChange("billing", "First_name", e.target.value)
                      }
                      required
                    />
                  </div> */}
                  {/* <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last Name"
                      value={formData.billing.Lirst_name}
                      onChange={(e) =>
                        handleInputChange("billing", "Lirst_name", e.target.value)}
                      required
                    />
                  </div> */}
                  {/* <div className="col-12 form-group">
              <input
                type="text"
                className="form-control"
                
                placeholder="Your Company Name"
                value={formData.billing.your_company_name}
                onChange={(e) =>
                  handleInputChange("billing", "your_company_name", e.target.value)
                }
                required
              />
            </div> */}
                  {/* <div className="col-12 form-group">
              <input
                type="text"
                className="form-control"
                
                placeholder="Street Address"
                value={formData.billing.street_address}
                onChange={(e) =>
                  handleInputChange("billing", "street_address", e.target.value)
                }
                required
              />
              <input
                type="text"
                className="form-control"
                
                placeholder="Apartment, suite, unit etc. (optional)"
                value={formData.billing.Apartment_no}
                onChange={(e) =>
                  handleInputChange("billing", "Apartment_no", e.target.value)
                }
                
              />
            </div> */}


                  {/* <div className="col-md-6 form-group">
             

            </div> */}
                  {/* <div className="col-md-6 form-group">
              <input
                type="number"
                className="form-control"
                placeholder="Postcode / Zip"
                value={formData.billing.postcode}
                onChange={(e) =>
                  handleInputChange("billing", "postcode", e.target.value)
                }
                required
              />
            </div> */}
                  {/* <div className="col-6 form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      value={formData.billing.Email_address}
                      onChange={(e) =>
                        handleInputChange("billing", "Email_address", e.target.value)
                      }
                    />
                  </div> */}
                  {/* <div className="col-6 form-group">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Phone number"
                      value={formData.billing.phone_no}
                      onChange={(e) =>
                        handleInputChange("billing", "phone_no", e.target.value)
                      }

                    />
                  </div> */}

                  <div className="col-6 form-group">

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Country"

                      value={formData.billing.Country_name}
                      onChange={(e) =>
                        handleInputChange("billing", "Country_name", e.target.value)
                      }
                     
                    />
                  </div>
                  <div className="col-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Town / City"
                      value={formData.billing.city}
                      onChange={(e) =>
                        handleInputChange("billing", "city", e.target.value)
                      }

                    />
                  </div>
                </div>
              </div>



              <div className="col-lg-7">
                <h4 className="mt-4 pt-lg-2">Your Order</h4>
                <form className="woocommerce-cart-form">
                  <table className="cart_table mb-20">
                    <thead>
                      <tr>
                        <th className="cart-col-image">Image</th>
                        <th className="cart-col-productname">Product Name</th>
                        <th className="cart-col-price">Price</th>
                        <th className="cart-col-quantity">Quantity</th>
                        <th className="cart-col-total">Total</th>
                      </tr>
                    </thead>

                    {
                      databasecartdata.map((curcart, index) => (

                        <tbody key={index}>
                          <tr className="cart_item">
                            <td data-title="Product">
                              <NavLink className="cart-productimage" to="/course"><img width={91} height={91} src={`${BASE_URL}${curcart.course_img}`} alt="Image" /></NavLink>
                            </td>
                            <td data-title="Name">
                              <NavLink className="cart-productname" to={`/course-detail/${curcart.slug}`}>{curcart.course_name}</NavLink>
                            </td>
                            <td data-title="Price">
                              <span className="amount"><bdi><span></span><Formatprice price={curcart.course_price} /></bdi></span>
                            </td>
                            <td data-title="Quantity">
                              <strong className="product-quantity">{curcart.quantity}</strong>
                            </td>
                            <td data-title="Total">
                              <span className="amount"><bdi><span></span><Formatprice price={curcart.total_price} /></bdi></span>
                            </td>
                          </tr>
                        </tbody>
                      ))}

                    <tfoot className="checkout-ordertable">
                      {/* <tr className="cart-subtotal">
            <th>Subtotal</th>
            <td data-title="Subtotal" colSpan={4}><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol"></span> <Formatprice price={total_cart_price}/></bdi></span></td>
          </tr> */}
                      {/* <tr className="woocommerce-shipping-totals shipping">
            <th>Shipping</th>
            <td data-title="Shipping" colSpan={4}> Enter your address to view shipping options.
            </td>
          </tr> */}
                      <tr className="order-total">
                        <th>Total</th>
                        <td data-title="Total" colSpan={4}><strong><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol"></span><Formatprice price={totalCartPrice ? totalCartPrice : 0} /></bdi></span></strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </form>



                <div className="mt-lg-3 mb-30">

                  <div className="woocommerce-checkout-payment">
                    {/* <ul className="wc_payment_methods payment_methods methods">
          <li className="wc_payment_method payment_method_bacs">
            <input id="payment_method_bacs" type="radio" className="input-radio" name="payment_method" defaultValue="bacs" defaultChecked="checked" />
            <label htmlFor="payment_method_bacs">Direct bank transfer</label>
            <div className="payment_box payment_method_bacs">
              <p>Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order will not be shipped until the funds have cleared in our account.
              </p>
            </div>
          </li>
          <li className="wc_payment_method payment_method_cheque">
            <input id="payment_method_cheque" type="radio" className="input-radio" name="payment_method" defaultValue="cheque" />
            <label htmlFor="payment_method_cheque">Cheque Payment</label>
            <div className="payment_box payment_method_cheque">
              <p>Please send a check to Store Name, Store Street, Store Town, Store State / County, Store Postcode.</p>
            </div>
          </li>
          <li className="wc_payment_method payment_method_cod">
            <input id="payment_method_cod" type="radio" className="input-radio" name="payment_method" />
            <label htmlFor="payment_method_cod">Credit Cart</label>
            <div className="payment_box payment_method_cod">
              <p>Pay with cash upon delivery.</p>
            </div>
          </li>
          <li className="wc_payment_method payment_method_paypal">
            <input id="payment_method_paypal" type="radio" className="input-radio" name="payment_method" defaultValue="paypal" />
            <label htmlFor="payment_method_paypal">Paypal</label>
            <div className="payment_box payment_method_paypal">
              <p>Pay via PayPal; you can pay with your credit card if you don’t have a PayPal account.</p>
            </div>
          </li>
        </ul> */}
                    <Wrapper>
                      <div className="form-row place-order">
                        {!isOrderPlaced ? (
                          <button type="button" className="th-btn" onClick={() => setShowModal(true)}>
                            Process to Pay
                          </button>
                        ) : (
                          <div className="success-message">
                            <div className="success-icon">
                              <span>&#10004;</span>
                            </div>
                            <p>Order Placed Successfully!</p>
                          </div>
                        )}
                      </div>
                    </Wrapper>
                  </div>
                </div>


              </div>


              {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header p-2">
                        <h5 className="modal-title">Payment</h5>
                        <button type="button" className="btn btn-danger th-btn" onClick={() => setShowModal(false)}>
                          <span>&times;</span>
                        </button>
                      </div>
                      <div className="modal-body text-center">
                        <img src="assets/img/auratech paymentqr/QR_of_auratech.jpg" alt="QR Code" style={{ width: '200px' }} />
                        <p className="mt-2">
                          <strong>UPI ID:</strong>9413561917@apl
                          <button onClick={() => {
                            navigator.clipboard.writeText(`9413561917@apl`);
                            setCopyText('Copied!');
                            setTimeout(() => setCopyText('Copy'), 2000);
                          }} className="btn btn-sm btn-outline-secondary ms-2">{copyText}</button>
                        </p>

                        <div className="form-group mt-2">
                          <label htmlFor="utr_no">UTR/Transaction ID</label>
                          <input
                            id="utr_no"
                            type="text"
                            name='utr_no'
                            className="form-control"
                            placeholder="Enter 10-16 digit UTR or transaction ID"
                            value={formData.billing.utr_no}
                            onChange={(e) =>
                              handleInputChange("billing", "utr_no", e.target.value)
                            }
                            // onChange={(e) => setUtr(e.target.value)}
                            required
                            maxLength={20} // optional limit
                            pattern="^[a-zA-Z0-9]{10,20}$" // optional validation
                            title="Please enter a valid UTR ID (10–20 alphanumeric characters)"
                          />
                        </div>

                        <div className="form-group">
                          <label>Upload Payment Screenshot</label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => setPaymentScreenshot(e.target.files[0])}
                            required
                          />
                        </div>
                      </div>

                      <div className="modal-footer p-2">
                        <button type="button" className="btn btn-danger th-btn" onClick={() => setShowModal(false)}>
                          <span> Cancel</span>
                        </button>
                        <button
                          onClick={() => formRef.current.requestSubmit()}
                          className="btn btn-success th-btn"
                        >
                          {
                            loading ?
                              <>
                                <div className='d-flex gap-2 align-items-center'>
                                  <span>Place Order....</span>
                                  <SubLoading />
                                </div>
                              </>
                              : (
                                <>
                                  Place Order<i className="fas fa-arrow-right ms-2" />
                                </>

                              )
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>

        </div>
      </div>
    </>
  )
}

const Wrapper = styled.section`
 .place-order-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f9f9f9;
  font-family: Arial, sans-serif;
}

.place-order-button {
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #4caf50;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.place-order-button:hover {
  background-color: #45a049;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e8f5e9;
  padding: 20px;
  border: 2px solid #4caf50;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  animation: fadeInScale 0.5s ease-in-out;
}

.success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4caf50;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  margin-bottom: 10px;
  animation: bounce 0.5s ease-in-out;
}

.success-message p {
  font-size: 18px;
  color: #4caf50;
  margin: 0;
}

/* Animations */
@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
`
export default Checkout
